import $ from 'jquery';

$(function () {
  if ($('#modal-video-player').length) {
    const $modalVideoPlayer = $('#modal-video-player');

    if ($('[data-action]').data('action')) {
      $('body').on('click', '[data-action]', (event) => {
        const { action, type } = $(event.currentTarget).data();

        type === 'youtube'
          ? $modalVideoPlayer.attr(
              'src',
              `https://www.youtube.com/embed/${action}`
            )
          : (window.location.href = action);
      });
    }
  }
});
